import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear(); // Get the current year dynamically
  return (
    <footer className="bg-light py-3 text-center">
      <p className="mb-0">© {currentYear} School of Service. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
